import { render, staticRenderFns } from "./Fancybox.vue?vue&type=template&id=32d0df47"
import script from "./Fancybox.vue?vue&type=script&lang=js"
export * from "./Fancybox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports